export default __webpack_public_path__ + "static/media/poca_antiguedad.72d4f7fb.png";